module.exports = {
  sanity: {
    projectId: "lwh2s6ps",
    dataset: 'production'
  }
}
